import { forwardRef } from 'react'
import styles from './currenttimestamp.css'

type CurrentTimestampProps = {
  playedRatio: number
  timestamp: string
  intersecting: boolean
}

const CurrentTimestamp = ({ intersecting, playedRatio, timestamp }: CurrentTimestampProps, ref) => {
  return (
    <div
      ref={ref}
      className={styles.currentTime}
      style={{
        left: `calc(${Math.min(playedRatio * 100, 95.5)}% + 12px)`,
        bottom: intersecting ? '16px' : 0,
      }}
    >
      {timestamp}
    </div>
  )
}

export default forwardRef(CurrentTimestamp)
